var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.56535 3.43899C7.56535 3.144 7.32622 2.90487 7.03124 2.90487C6.73625 2.90487 6.49712 3.144 6.49712 3.43899V6.99977C6.49712 7.20208 6.61142 7.38702 6.79237 7.4775L9.16622 8.66442C9.43007 8.79634 9.7509 8.6894 9.88282 8.42556C10.0147 8.16172 9.9078 7.84089 9.64395 7.70897L7.56535 6.66967V3.43899Z",
    fill: "#009C64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03125 0.53125C3.45866 0.53125 0.5625 3.42741 0.5625 7C0.5625 10.5726 3.45866 13.4688 7.03125 13.4688C10.6038 13.4688 13.5 10.5726 13.5 7C13.5 3.42741 10.6038 0.53125 7.03125 0.53125ZM1.63073 7C1.63073 4.01738 4.04863 1.59948 7.03125 1.59948C10.0139 1.59948 12.4318 4.01738 12.4318 7C12.4318 9.98262 10.0139 12.4005 7.03125 12.4005C4.04863 12.4005 1.63073 9.98262 1.63073 7Z",
    fill: "#009C64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.0fb064310fab89f812edf1d93f714a4a.svg";
export { ForwardRef as ReactComponent };